import {
  ISeatingGuestDto,
  IUpdateSeatingTableDto,
  IEmptyTableDto,
  ICancelOrderTicketDto,
} from "amnRestaurants/tableOrders/restTable";
import axios from "axios";
import getApiBaseUrl from "helpers/getApiBaseUrl";

const baseUrl = getApiBaseUrl();

function GetPosSections(posId: string) {
  return axios.get(baseUrl + `tableOrders/get-pos-section/${posId}`);
}

function getTablesSections(sectionId: string) {
  return axios.get(
    baseUrl + `tableOrders/get-pos-sectionTable-list/${sectionId}`
  );
}

function seatingGuest(data: ISeatingGuestDto) {
  return axios.post(baseUrl + `tableOrders/seating-guest`, { dto: data });
}

function updateSeatingGuest(data: IUpdateSeatingTableDto) {
  return axios.post(baseUrl + `tableOrders/update-seating-guest`, {
    dto: data,
  });
}

function emptyTable(data: IEmptyTableDto) {
  return axios.post(baseUrl + `tableOrders/empty-table`, { dto: data });
}

function GetTableOrderTicketList(tableId: string) {
  return axios.post(baseUrl + `tableOrders/table-ticket-list`, {
    tableOrderId: tableId,
  });
}

function emptyTableForCurrentOrderWithNoTickets(currentOrderId: string) {
  return axios.post(
    baseUrl + `tableOrders/empty-table-for-current-order_with-no-tickets`,
    { currentOrderId: currentOrderId }
  );
}
function cancelOrderTicket(dto: ICancelOrderTicketDto) {
  return axios.post(baseUrl + `tableOrders/cancel-order-table-tickets`, {
    tableOrderId: dto.tableOrderId,
    tickets: dto.tickets,
    cancellationNote: dto.cancellationNote,
    reasonId: dto.reasonId,
    clearTable: dto.clearTable,
  });
}

function mergeTableOrders(dto: string[]) {
  return axios.post(baseUrl + `tableOrders/merge-order-table-tickets`, {
    ticketList: dto,
  });
}

function moveTableOrderTickets(payload: {
  currentOrderId: string;
  toTableId?: string;
  ticketItemIds: string[];
  emptyCurrent: boolean;
}) {
  return axios.post(baseUrl + `tableOrders/move-order-to-table`, payload);
}

function moveTicketItems(payload: {
  sourceTicketId: string;
  destinationTicketId: string | null;
  ticketItems: {items:{id: string, qty: number}}[];

}) {
  return axios.post(baseUrl + `tableOrders/move-ticket-items-to-order`, payload);
}

const tableOrdersApi = {
  GetPosSections,
  getTablesSections,
  seatingGuest,
  updateSeatingGuest,
  emptyTable,
  emptyTableForCurrentOrderWithNoTickets,
  GetTableOrderTicketList,
  cancelOrderTicket,
  mergeTableOrders,
  moveTableOrderTickets,
  moveTicketItems,
};

export default tableOrdersApi;
